import { TagToken } from 'tag/ts/smart_tag/model/enums/TagToken';
export class TagConstants {
    static _instance = new TagConstants();
    constructor() {
        if (TagConstants._instance) {
            throw new Error(this.name + ' is a Singleton and can only be accessed through ' + this.name + '.getInstance()');
        }
        TagConstants._instance = this;
    }
    get name() {
        return 'TagConstants';
    }
    get DAI_IU() {
        return {
            desktop: '/8264/vaw-can/desktop/' + TagToken.PARTNER_ID,
            mobile: '/8264/vaw-can/mobile_web/' + TagToken.PARTNER_ID + '_mobile'
        };
    }
    get ADOPS_ID() {
        return {
            CMSID: 2497752
        };
    }
    get DAI_SDK_VOD_ENABLED() {
        return true;
    }
    static getInstance() {
        return TagConstants._instance;
    }
}
